import { A } from '@mobily/ts-belt';
import { Box, FormHelperText, List, ListItem } from '@mui/material';
import { useTranslate } from 'react-admin';

import { MatchingContributionCeilingOverrunRow } from '@sh4res/bo-common/components/B2bCampaigns/steps/allocations/matchingContributionCeilings';
import { convertCentsInUnits } from '@sh4res/bo-common/utils';

type Props = {
  ceilingOverruns: MatchingContributionCeilingOverrunRow[];
};

export const MatchingContributionCeilingSection = ({ ceilingOverruns }: Props) => {
  const translate = useTranslate();

  if (A.isEmpty(ceilingOverruns)) {
    return null;
  }

  return (
    <Box mt={1} sx={{ overflowY: 'auto', maxHeight: '80px' }}>
      <FormHelperText sx={{ fontSize: 14, color: 'error.main' }}>
        {translate(
          'resources.bo_common.b2b.campaigns.sections.review.errors.matching_contribution_ceiling_exceeded',
        )}
        :
        <List dense disablePadding>
          {ceilingOverruns.map((overrun, index) => (
            <ListItem key={index} sx={{ display: 'list-item', pl: 2 }}>
              {`${overrun.identifier} - ${overrun.firstname} ${overrun.lastname} : ${overrun.savingPlanCategory} ${translate(
                'resources.bo_common.b2b.campaigns.sections.review.errors.matching_contribution_ceiling_exceeded_by',
                { amount: convertCentsInUnits(overrun.exceededBy) },
              )}`}
            </ListItem>
          ))}
        </List>
      </FormHelperText>
    </Box>
  );
};
